export {default} from './ErrorBoundaryProvider.connect';
